import { roleCategories, type RoleName, type RoleCategory } from '~/modules/adminusers/model'

export const businessUnitRolePrefix = 'bu-'

export const convertToRoleCategories = (roleNames: RoleName[], filterCategoryRoles: boolean): RoleCategory[] =>
  roleCategories
    .map((category) => ({
      name: category.name,
      roles: filterCategoryRoles
        ? category.roles.filter((role) => roleNames.some((roleName) => roleName === role))
        : category.roles,
    }))
    .filter((category) => category.roles.length > 0)

export const convertBusinessUnitToRole = (businessUnit: string) =>
  `${businessUnitRolePrefix}${businessUnit}` as RoleName

export const convertRoleToBusinessUnit = (roleName: string) => roleName.slice(3)

export const convertToBusinessUnits = (roleNames: RoleName[]) => {
  const businessUnitRoles = roleNames.filter((roleName) => roleName.startsWith(businessUnitRolePrefix))
  return businessUnitRoles.map(convertRoleToBusinessUnit)
}
